import {
  HeroSection,
  HeroContent,
  Greeting,
  Name,
  Subtitle,
  Description,
  PortraitColumn,
  StripePattern,
  PortraitFrame,
  ScrollIndicator,
} from "./Hero.styles";

import { useState, useEffect } from "react";
import useHasMounted from "../../hooks/useHasMounted";

const SCROLL_FADE_THRESHOLD_VH = 20;

const Hero = () => {
  const hasMounted = useHasMounted();
  const [scrollFadeOut, setScrollFadeOut] = useState(false);

  useEffect(() => {
    const thresholdPx = (window.innerHeight * SCROLL_FADE_THRESHOLD_VH) / 100;

    const handleScroll = () => {
      setScrollFadeOut(window.scrollY >= thresholdPx);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <HeroSection className={hasMounted ? "is-visible" : ""}>
      <HeroContent>
        <Greeting>Hi, my name is</Greeting>
        <Name>Maria An</Name>
        <Subtitle>
          Software Engineer turning product ideas into reliable web experiences.
        </Subtitle>
        <Description>
          I'm a <strong>Software Engineer</strong> focused on{" "}
          <strong>React</strong>, <strong>TypeScript</strong>, and{" "}
          <strong>Node.js</strong>, building full-stack web apps from idea to
          production, working closely with designers and product teams to ship
          scalable, user-centered features, from high-traffic campaigns to
          long-lived applications. Based in the New York City area, open to
          hybrid or remote roles.
        </Description>
      </HeroContent>

      <PortraitColumn>
        <StripePattern aria-hidden="true" />
        <PortraitFrame>
          <img
            src="/hero-portrait.png"
            alt="Maria An"
            width={320}
            height={320}
            loading="eager"
          />
        </PortraitFrame>
      </PortraitColumn>

      <ScrollIndicator $fadeOut={scrollFadeOut}>Scroll</ScrollIndicator>
    </HeroSection>
  );
};

export default Hero;
